module.exports = __webpack_public_path__ + "static/media/427JamesPBrawleyDrNW_2018-06-12_82.19f52d85.jpg";